import { render, staticRenderFns } from "./RangesViewScreen.vue?vue&type=template&id=67461208&scoped=true&"
import script from "./RangesViewScreen.vue?vue&type=script&lang=ts&"
export * from "./RangesViewScreen.vue?vue&type=script&lang=ts&"
import style0 from "./RangesViewScreen.vue?vue&type=style&index=0&id=67461208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67461208",
  null
  
)

/* custom blocks */
import block0 from "./RangesViewScreen.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports